import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { FilterService } from '../../../services/filter.service';
import { Filter } from '../../../shared/object/filter';
import { TerritoryService } from "../../../services/geolocation/territory.service";
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-filter-button',
    templateUrl: './filter-button.component.html',
    styleUrls: ['./filter-button.component.css'],
    imports: [NgClass, TranslateModule]
})
export class FilterButtonComponent implements OnInit {

  currentTerritoryCode: string;
  isActive: boolean = false;

  @Input() filter: Filter;
  @Input() loadedIndex: number;
  @Input() updateItemsFunction: () => void;

  isMobile: boolean = false;

  private filterService: FilterService = inject(FilterService);
  private territoryService: TerritoryService = inject(TerritoryService);
  private platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);


  ngOnInit(): void {
    this.isMobile = this.isBrowser ? window.innerWidth < 768 : false;
    this.currentTerritoryCode = this.territoryService.getTerritoryCodeFromUrl();
    this.isActive = this.filterService.getFilterStatus(this.filter.API_name);
  }

  @HostListener('window:resize', ['$event'])
  private onResize(): void {
    if (!this.isBrowser) {
      return;
    }
    this.isMobile = window.innerWidth < 768;
  }

  toggle(): void {
    if (this.filterService.checkIfNotLastActiveFilter(this.filter.API_name)) {
      this.isActive = this.filterService.changeFilterStatus(this.filter.API_name);
      this.loadedIndex = 0;
      this.updateItemsFunction();
    }
  }

  getFilterClasses(): string[] {
    const baseClasses = [
      'rounded-full',
      'flex',
      'items-center',
      'justify-center',
      'px-3',
      'py-2',
      'transition-all',
      'duration-300',
      'border-[1px]',
      'custom-border-color'
    ];

    if (this.isActive) {
      baseClasses.push('custom-background-color');
    } else {
      baseClasses.push('bg-white');
    }

    return baseClasses;
  }

  getFilterTextClasses() {
    const baseClasses = [
      'text-sm',
      'text-center',
      'font-semibold'
    ];

    if (this.isActive) {
      baseClasses.push('text-white');
    }

    return baseClasses;
  }
}
